import fnsFormat from "date-fns/format";

export const dateFormat = (date: string, format?: string) => {
  return fnsFormat(new Date(date), format ?? "dd/mm/yy, hh:mm");
};
